<template>
    <div class="contents">
        <div class="sub_inner">
            <div class="contents-title">
                <h3>{{menuInfo.menuName}}</h3>
            </div>
            <div class="board_con">
                <div class="tab_content">

                    <!-- 일반 -->
                    <div class="board_view">
                        <div class="board_view_thead">
                            <div class="board_view_tit">
                                <div class="board_view_text">
                                    <div class="board_view_tit-division" v-if="resultData.boardNo == 96">
                                        <span class="board__table-situation deadline">안암</span>
                                    </div>
                                    <p class="tit">{{ articleInfo.title }}</p>
                                </div>
                                <div class="board_view_info ">
                                    <ul class="con">
                                        <li>
                                            <img src="@/assets/resource/images/icon/board_icon_01.png" alt="날짜"> {{ $timestempToDateFormat(articleInfo.createdDt) }}
                                        </li>
                                        <li>
                                            <img src="@/assets/resource/images/icon/board_icon_02.png" alt="조회수"> {{ articleInfo.readCnt }}
                                        </li>
                                    </ul>
                                </div>
                            </div>                            

            
                        </div>
                        <!-- 교육안내 -->
                        <ul class="board-view__list" v-if="articleInfo.boardType == 'P'">
                            <li class="board-view__item">
                                <span class="board-view__item-name">진행여부</span>
                                <span class="board-view__item-desc">{{ articleInfo.eduApply }}</span>
                            </li>
                            <li class="board-view__item">
                                <span class="board-view__item-name">신청기간</span>
                                <span class="board-view__item-desc">{{ articleInfo.item6 }} ~ {{ articleInfo.item7 }}</span>
                            </li>
                            <li class="board-view__item">
                                <span class="board-view__item-name">교육기간</span>
                                <span class="board-view__item-desc">{{ articleInfo.item8 }} ~ {{ articleInfo.item8 }}</span>
                            </li>
                            <li class="board-view__item">
                                <span class="board-view__item-name">교육장소</span>
                                <span class="board-view__item-desc">{{ articleInfo.item10 }}</span>
                            </li>
                            <li class="board-view__item">
                                <span class="board-view__item-name">신청서</span>
                                <a href="javascript:;" v-for="(attach, idx) in articleApply" :key="idx" @click="this.$fileDownload(attach.attachNo, attach.displayName)" class="board-view__item-desc">
                                    <img src="@/assets/resource/images/icon/file_icon.png" alt="파일내려받기">
                                </a> 
                            </li>
                            <li class="board-view__item">
                                <span class="board-view__item-name">조편성</span>                                    
                                <a href="javascript:;" v-for="(attach, idx) in articleTeam" :key="idx" @click="this.$fileDownload(attach.attachNo, attach.displayName)" class="board-view__item-desc">
                                    <img src="@/assets/resource/images/icon/file_icon.png" alt="파일내려받기">
                                </a> 

                            </li>
                                </ul>
                        <div class="board_view_tbody">
                            <!-- 상세 내용-->
                            <div v-if="this.menuInfo.boardNo === '231'" >
                                <div v-html="getContent" class="board_view_content" style="border-bottom: none; padding-bottom: 0px; word-break: break-all; line-height: 30px; padding-bottom: 30px;"></div>
                                <div style="padding: 0px 70px; display: flex;">
                                    <div>
                                        <p style="font-weight: bold; padding-bottom: 10px; margin-right: auto;">{{this.articleInfo.item9}}</p>
                                        <p style="line-height: 30px">{{this.articleInfo.item10}}</p>
                                    </div>
                                    <div v-if="articleInfo.attachBag != null">
                                        <img :src="`/displayFile.do?name=${articleInfo.attachBag.thumbs[0].savedName}`" alt="" v-if="articleInfo.attachBag.thumbs != undefined" style="width: 100%; max-width: 500px; min-width: 400px; height: auto; padding: 10px;">
                                        <img src="@/assets/resource/images/sub/substitution_img.jpg" alt="" v-else />
                                    </div>
                                </div>
                            </div>
                            <div v-html="getContent" class="board_view_content" v-else></div>
                            <!-- 첨부파일 -->
                            <div class="board_view_file" v-if="articleAttach.length > 0">
                                <p class="tit">Attachment</p>
                                <div class="file_list">
                                    <a href="javascript:;" v-for="(attach, idx) in articleAttach" :key="idx" @click="this.$fileDownload(attach.attachNo, attach.displayName)">
                                        <span>{{attach.displayName}}</span>
                                        <em class="icon_downlode"></em>
                                    </a>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                                        
                    <ul class="board_page">
                        <li class="prev none">
                            <em>Next</em>
                            <p class="tit" v-if="nextArticle.title">
                                <a href="javascript:;" @click="$goArticle(nextArticle)">{{ nextArticle.title }}</a>
                            </p>
                            <p class="tit" v-else>No next.</p>
                        </li>
                        <li class="next">
                            <em>Prev</em>
                            <p class="tit" v-if="prevArticle.title">
                                <a href="javascript:;" @click="$goArticle(prevArticle)">{{ prevArticle.title }}</a>
                            </p>
                            <p class="tit" v-else>No previous.</p>
                        </li>
                    </ul>
                    <div class="btn_wrap">
                        <router-link :to="`${listPagePath}`" class="btn_type01">List</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        
    },
    data() {
        return {
            menuInfo : {},
            resultData : [],
            articleNo: '',      
            listPagePath : '',
            articleInfo : {},
            prevArticle : {},
            nextArticle : {},
            articleAttach : [],
            articleTeam : [],
            articleApply : [],
            category : ''
        }
    },
    watch: {
        $route(to, from) {
            if (to.fullPath !== from.fullPath) {
                document.querySelector('.menu-con').classList.remove('show');
                this.init();
                this.getInfo();
            }
        }
    },
    created() {
        this.init();
    },
    computed: {
        getContent() {
            return this.articleInfo.content;
        }
    },
    methods: {
		init() {
            this.category = this.$route.query.category || '';

            this.listPagePath = this.$route.path.replace("/view", '/list');

            if(this.$route.query.category){ 
                this.listPagePath += '?category=' + this.$route.query.category; 
            } 

            for (let i = (this.menuList.length - 1); i > 0; i--) {
                if(this.menuList[i].menuUrl === this.listPagePath){
                    this.menuInfo = this.menuList[i];
                    break;
                }           
            }
            
            if (this.$store.state.boardNoStore.boardNo == '') {
                this.$store.commit('getBoardNo', this.menuInfo.boardNo);
            }      

            this.articleNo = this.$route.query.articleNo; 
            this.articleInfo = {};
            this.prevArticle = {};
            this.nextArticle = {};
            this.articleAttach = [];
            this.articleTeam = [];
            this.articleApply = [];
        },
        getInfo(){         
            this.articleList = [];
			var searchParam = {
                'instNo' : this.$store.state.hpInfoStore.instNo,
                'boardNo': this.$store.state.boardNoStore.boardNo,
                'articleNo' : this.articleNo,
                'category' : this.category
        	};

        	this.axios({
                method:"get",
                url: this.$store.state.kumcApi.articleApi.article + this.menuInfo.boardNo + '/' + this.articleNo, 
                params: searchParam
            }).then(response => {
                this.articleInfo = response.data;
                this.articleInfo.eduApply = this.eduApplyDate(this.articleInfo.item6, this.articleInfo.item7);
                if (response.data.prevArticle != null){         
                    this.prevArticle = response.data.prevArticle;
                }

                if (response.data.nextArticle != null) {
                    this.nextArticle = response.data.nextArticle;               
                }

                if(response.data.attachBag.attach){
                    this.articleAttach = response.data.attachBag.attach;                    
                }

                if(response.data.attachBag.team){
                    this.articleTeam = response.data.attachBag.team;
                }

                if(response.data.attachBag.application){
                    this.articleApply = response.data.attachBag.application;
                }
            });
        },
        //오늘 기준으로 교육신청기간 여부 확인
        eduApplyDate : function( fromDate, toDate) {
            var rtn = "접수마감";
            var today = new Date();
            var from = new Date(fromDate);
            var to = new Date(toDate);

            if(from > today){
                rtn = "접수전";
            } else if(from <= today &&  today <= to){
                rtn = "진행중";
            }

            return rtn;
        },
    },
    mounted() {
        this.getInfo();        
    },
    beforeUnmount() {
       
    }
}
</script>